import { useState } from 'react'

import { useTranslation } from 'react-i18next'
import { useNavigate, useSearchParams } from 'react-router-dom'

import clsx from 'clsx'

import { RoutingPaths } from 'app/routes/routes'

import { Files, ScanMediaTunduk } from 'features/scan-media-tunduk'

import formPassengersStore from 'entities/ticket/models/form-passengers/form-passengers-store'

import { IScanDocument, ScanDocument } from 'shared/api/scan-document'
import { TYPE_AGE } from 'shared/constants'
import { getErrorMessage } from 'shared/lib/errorText'
import { useDialogBottomSheet } from 'shared/ui/dialog-bottom-sheet/lib'
import { HeaderGoBack } from 'shared/ui/header-go-back'
import { Loader } from 'shared/ui/loader'

import {
  DialogScanPassport,
  DialogScanPassportError,
} from '../scan-document/components'

import s from './styles.module.scss'

const ScanDocumentTunduk = () => {
  const { t } = useTranslation()

  const { openDialog } = useDialogBottomSheet()

  const [loading, setLoading] = useState<boolean>(false)

  const [searchParams] = useSearchParams()

  const navigate = useNavigate()

  const indexPassenger = searchParams.get('passenger')

  const agePassenger = searchParams.get('age') as TYPE_AGE

  const onRequestFile = async (files: Files) => {
    if (!files?.backFile || !files?.frontFile) return

    setLoading(true)

    try {
      const formData = new FormData()

      formData.append('file', files?.frontFile)
      formData.append('file', files?.backFile)

      const { data: scanResult } = await ScanDocument.scanUserDocument(formData)

      openDialog({
        isDialog: false,
        child: (
          <DialogScanPassport
            data={scanResult.data}
            onContinue={() => onSubmitScanDocument(scanResult?.data)}
          />
        ),
      })
    } catch (error) {
      const errorText = getErrorMessage(error)

      onShowError(errorText)
    } finally {
      setLoading(false)
    }
  }

  const onShowError = (errorText?: string) => {
    openDialog({
      isDialog: false,
      child: (
        <DialogScanPassportError
          text={errorText || t('scan_passport.error_scaning_password')}
        />
      ),
    })
  }

  const onSubmitScanDocument = (data: IScanDocument) => {
    if (!indexPassenger || !agePassenger) {
      onShowError()

      return
    }

    formPassengersStore.setPassengerData({
      index: Number(indexPassenger),
      age: agePassenger,
      scannedData: data,
    })

    navigate(RoutingPaths.avia.purchase.path(), {
      replace: true,
    })
  }

  return (
    <div className={s.container}>
      <HeaderGoBack
        variant="grey"
        title={t('screenshot_from_tunduk')}
        buttonWhite
      />

      {loading ? (
        <Loader marginTop={150} />
      ) : (
        <div className={clsx('container', s.content)}>
          <p className={clsx('regular-13', s.description)}>
            {t('load_passport_description')}
          </p>
          <ScanMediaTunduk onLoadFile={onRequestFile} />
        </div>
      )}
    </div>
  )
}

export default ScanDocumentTunduk
